import * as React from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import '@/styles/org/header.scss';

const Header = ({ siteTitle }) => (
  <header className='container'>
    <div className='inner'>
      <h1>
        <Link to="/">
          <StaticImage
            src='../images/logo_white.svg'
            alt={siteTitle}
            width={160}
            quality={95}
            style={{ marginRight: `1.45rem` }}
          />
        </Link>
      </h1>
      <div className='menu'>
        <Link to="/">Home</Link>
        <Link to="/about/">About</Link>
      </div>
    </div>
  </header>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
